module.exports = __webpack_public_path__ + "img/hand.c6e1bd44.png";